<main>
  <div class="fake-disabled" *ngIf="setTimeCSV"></div>

  <div class="page-wrapper">
    <!-- Overlay -->
    <div class="loader-overlay" *ngIf="showLoaderOverlay">
      <div class="spinner-wrapper">
        <app-loader-overlay></app-loader-overlay>
      </div>
    </div>

    <!-- Content -->
    <div class="loaded-content" [class.blurred]="!showLoaderOverlay">
      <!-- Breadcrumbs -->
      <xng-breadcrumb>
        <div class="breadcrumbs" *xngBreadcrumbItem="let breadcrumb">
          <div class="container-xl">
            <ul class="breadcrumbs-list">
              <li><a [routerLink]="['/home']">Home</a></li>
              <li>
                <a>{{ breadcrumb }}</a>
              </li>
            </ul>
          </div>
        </div>
      </xng-breadcrumb>

      <!-- Title Bar -->
      <lib-title-bar title="{{ pageTitle }}"></lib-title-bar>

      <section *ngIf="noDataFound === true" class="container-xl">
        <div class="not-found">
          <img src="./assets/images/icons/not_tasks.png" alt="No data found." class="img-notFound" />
          No data found. <strong></strong>
        </div>
      </section>

      <section class="container-xl">
        <div class="top-cards-list">
          <div class="top-cards">
            <ng-container *ngFor="let card of orderedCards; let i = index">
              <div
                [class.card-sm]="true"
                [ngClass]="card.class"
                [class.card-active]="!card?.selected"
                (click)="onCardClick(card)"
              >
                <strong class="card-title">{{ card.title || ' - ' }}</strong>
                <span class="card-total">{{ card.quantity | number: '1.0-0' }}</span>
              </div>
            </ng-container>
          </div>
          <div *ngIf="this.setup !== undefined && this.setup?.createNewBtn" class="btn-new">
            <button
              (click)="createSetup()"
              matTooltip="{{ this.setup.createNewBtn.buttonTooltip | uppercase }}"
              matTooltipPosition="before"
              [ngClass]="expandedElement || !transformToggle ? '' : 'm-0'"
            >
              <i class="fa-solid fa-circle-plus"></i>
              {{ this.setup.createNewBtn.buttonTitle }}
            </button>
          </div>
        </div>

        <!-- <button class="open-dialog" (click)="openStatusModal()">status modal</button> Temp -->

        <!-- </div> -->

        <div *ngIf="this.setup === undefined" class="item">
          <ngx-skeleton-loader
            count="3"
            appearance="circle"
            [theme]="{
              width: '120px',
              height: '40px',
              'border-radius': '8px',
              'background-color': '#E2E1EB',
              margin: '0',
              'margin-right': '10px'
            }"
          >
          </ngx-skeleton-loader>
        </div>

        <div class="content-filter" [ngClass]="expandedElement ? '' : 'readapted'">
          <app-table-skeleton *ngIf="this.setup === undefined || clickCard === false" [tableType]="'bigSize'">
          </app-table-skeleton>
          <app-table-ag-grid
            *ngIf="this.setup !== undefined && clickCard === true"
            [respTable]="this.setup.table.data"
            (customCellClick)="onCustomCellClick($event)"
            [exportCsv]="false"
            [height]="'80%'"
            class="ag-roles"
          ></app-table-ag-grid>
        </div>
      </section>
    </div>
  </div>
</main>
